import { motion } from 'framer-motion';
import { Card, CardContent } from '../components/ui/card';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 }
};


export const PoliciesPage = () => {

  const location = useLocation();

useEffect(() => {
  if (location.hash) {
    const element = document.getElementById(location.hash.replace('#', ''));
    if (element) {
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }
}, [location]);
  return (
    <div className="min-h-screen bg-[#F7F9FC]">

      {/* Hero Section */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <motion.div {...fadeInUp}>
            <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#3A7BD5] mb-4 block">
              Legal & Policies
            </span>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#1E4F8A] mb-6">
              Policies & Terms
            </h1>
            <p className="text-lg text-[#4A5568] leading-relaxed">
              Please review our policies below. These outline how we operate, 
              your rights, and how we ensure a safe and professional service.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Policies Content */}
      <section id="terms" className="py-20 md:py-28 bg-[#F7F9FC]">
        <div className="max-w-4xl mx-auto px-4 space-y-10">

          {/* TERMS */}
          <motion.div {...fadeInUp} id="terms">
            <Card className="bg-white border-[#E2E8F0]">
              <CardContent className="p-8 md:p-10">
                <h2 className="font-serif text-2xl md:text-3xl text-[#1E4F8A] mb-6">
                  Terms & Conditions
                </h2>
       <div className="space-y-8 text-[#4A5568] text-base leading-relaxed">

  <p>
    AERW Lifestyle provides non-regulated companionship and lifestyle support services only. 
    We do not provide personal care, medical care, or any services requiring regulation by the Care Quality Commission (CQC).
  </p>

  {/* Scope */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Scope of Services</h4>
    <ul className="space-y-2">
      <li>• Companionship visits and social interaction</li>
      <li>• Accompanied outings and activities</li>
      <li>• Appointment support</li>
      <li>• Light household assistance</li>
      <li>• No personal care, medication, or clinical services</li>
    </ul>
  </div>

  {/* Bookings */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Bookings & Agreements</h4>
    <ul className="space-y-2">
      <li>• All services must be agreed in advance</li>
      <li>• Services must fall within our non-regulated scope</li>
      <li>• A consultation may be required before starting services</li>
    </ul>
  </div>

  {/* Cancellations */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Cancellations</h4>
    <ul className="space-y-2">
      <li>• Reasonable notice is required for cancellations</li>
      <li>• Late cancellations may incur a fee</li>
      <li>• Rescheduling is subject to availability</li>
    </ul>
  </div>

  {/* Responsibilities */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Client Responsibilities</h4>
    <ul className="space-y-2">
      <li>• Provide accurate information about needs</li>
      <li>• Maintain respectful and appropriate behaviour</li>
      <li>• Ensure a safe environment for companions</li>
    </ul>
  </div>

  {/* Boundaries */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Boundaries of Service</h4>
    <ul className="space-y-2">
      <li>• We do not provide regulated care services</li>
      <li>• We may decline requests outside our scope</li>
      <li>• Services may be withdrawn if boundaries are breached</li>
    </ul>
  </div>

  {/* Liability */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Liability</h4>
    <ul className="space-y-2">
      <li>• We take reasonable care in service delivery</li>
      <li>• We are not liable for indirect or unforeseen outcomes</li>
      <li>• Clients remain responsible for personal decisions</li>
    </ul>
  </div>

  {/* Safeguarding */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Safeguarding</h4>
    <ul className="space-y-2">
      <li>• We prioritise safety and wellbeing at all times</li>
      <li>• Concerns may be reported where necessary</li>
      <li>• Appropriate safeguarding actions may be taken</li>
    </ul>
  </div>

  {/* Updates */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Changes to Terms</h4>
    <ul className="space-y-2">
      <li>• Terms may be updated periodically</li>
      <li>• Continued use of services implies acceptance</li>
    </ul>
  </div>

</div>
              </CardContent>
            </Card>
          </motion.div>

          {/* PRIVACY */}
          <section id="privacy" className="py-20 bg-[#F7F9FC]"></section>
          <motion.div {...fadeInUp} id="privacy">
            <Card className="bg-white border-[#E2E8F0]">
              <CardContent className="p-8 md:p-10">
                <h2 className="font-serif text-2xl md:text-3xl text-[#1E4F8A] mb-6">
                  Privacy Policy
                </h2>
                <div className="space-y-8 text-[#4A5568] text-base leading-relaxed">

  <p>
    We respect your privacy and are committed to protecting your personal information.
  </p>

  {/* Data We Collect */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Information We Collect</h4>
    <ul className="space-y-2">
      <li>• Name and contact details</li>
      <li>• Information provided through enquiry forms</li>
      <li>• Details relevant to arranging companionship services</li>
    </ul>
  </div>

  {/* How We Use It */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">How We Use Your Information</h4>
    <ul className="space-y-2">
      <li>• To respond to enquiries and provide services</li>
      <li>• To communicate regarding bookings and support</li>
      <li>• To improve our services and client experience</li>
    </ul>
  </div>

  {/* Data Protection */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Data Protection</h4>
    <ul className="space-y-2">
      <li>• Your data is stored securely</li>
      <li>• We do not sell or share your data with third parties</li>
      <li>• Information is only used where necessary for service delivery</li>
    </ul>
  </div>

  {/* Your Rights */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Your Rights</h4>
    <ul className="space-y-2">
      <li>• Request access to your personal data</li>
      <li>• Request correction or deletion of your data</li>
      <li>• Withdraw consent at any time</li>
    </ul>
  </div>

</div>
              </CardContent>
            </Card>
          </motion.div>

          {/* COMPLAINTS */}
          <section id="complaints" className="py-20 bg-white"></section>
          <motion.div {...fadeInUp} id="complaints">
            <Card className="bg-white border-[#E2E8F0]">
              <CardContent className="p-8 md:p-10">
                <h2 className="font-serif text-2xl md:text-3xl text-[#1E4F8A] mb-6">
                  Complaints Policy
                </h2>
                <div className="space-y-8 text-[#4A5568] text-base leading-relaxed">

  <p>
    We are committed to providing a high-quality service and take all feedback seriously.
  </p>

  {/* Raising a Complaint */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Raising a Complaint</h4>
    <ul className="space-y-2">
      <li>• Complaints can be made via phone or email</li>
      <li>• Please provide as much detail as possible</li>
      <li>• We aim to make the process simple and accessible</li>
    </ul>
  </div>

  {/* Response Time */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Response Time</h4>
    <ul className="space-y-2">
      <li>• Acknowledgement within 48 hours</li>
      <li>• Prompt investigation of the issue</li>
      <li>• Clear communication throughout the process</li>
    </ul>
  </div>

  {/* Resolution */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Resolution</h4>
    <ul className="space-y-2">
      <li>• We aim to resolve complaints fairly and quickly</li>
      <li>• Outcomes will be communicated clearly</li>
      <li>• Improvements may be made based on feedback</li>
    </ul>
  </div>

  {/* Commitment */}
  <div>
    <h4 className="font-semibold text-[#1E4F8A] text-lg mb-3">Our Commitment</h4>
    <ul className="space-y-2">
      <li>• All complaints are handled confidentially</li>
      <li>• We act without bias or prejudice</li>
      <li>• Feedback helps us improve our service</li>
    </ul>
  </div>

</div>
              </CardContent>
            </Card>
          </motion.div>

        </div>
      </section>

    </div>
  );
};

export default PoliciesPage;